// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-body {
  padding-top: 4rem;
  background-image: url("https://cdn.elluciancloud.com/assets/EDS2/7.18.1/img/bg/DegreeWorks-CRM-Background.png");
  background-size: cover;
}

.logout-body {
  background-image: url("https://cdn.elluciancloud.com/assets/EDS2/7.18.1/img/bg/DegreeWorks-CRM-Background.png");
  background-size: cover;
}

.loadingIndicator {
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 10100;
}

.dashboard-body {
  background-color: #fafafa;
}

@media print {
  .dashboard-body {
    background-color: #ffffff;
  }

  body {
    font: 9pt/1.5 Arial, sans-serif;
  }

  * {
    overflow: visible !important;
  }

  #tooltip-icon-print {
    display: none;
  }
}

.no-padding {
  padding: 0;
}

h1 {
  padding-Top: 0.45rem !important;
}

.note-component:hover {
  background-color: #f8f8f8;
  cursor: pointer;
}

.note-component:hover>td>div>span {
  text-decoration: underline;
}

.entity-component:hover {
  background-color: #f8f8f8;
  cursor: pointer;
}

.entity-component:hover>td:first-child {
  text-decoration: underline;
}

.interal-field-width {
  min-width: 75px;
}

.button-margin {
  margin: 3px;
}

div.errorNotification {
  top: 0;
}

div.errorNotification>div {
  background-color: #D42828;
}

.hidden {
  display: none !important;
}

footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  border-top: 0.0625rem solid #ccc;
}

.fade {
  transition: all 1s ease-in-out;
  opacity: 0;
  display: none;
}

button.fab {
  position: fixed;
  bottom: 1rem;
  right: 0.5rem;
}

/* Override material-ui OutlinedInput dropdown which we can't figure out how to get to through PaperProps, like in What-If */
ul {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.truncationContainer {
  position: relative;
  overflow: hidden;
  height: 1em;
}

.truncationContent {
  display: block;
  position: absolute;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1em;
}

/* petitionRowExpanded */
.petitionTable .table-row-expanded .truncationContainer {
  overflow: visible;
  height: unset;
}

.petitionTable .table-row-expanded .truncationContent {
  white-space: normal;
  position: relative;
  line-height: unset;
}

/* On some of the Exception Management pages we do not want to see the new
/* row but we do want the down-arrow to allow the column to expand.
/* Here we are hiding the row using visibility:collapse */
.petitionTableNoExpand .table-row-expanded .truncationContainer {
  overflow: visible;
  height: unset;
}

.petitionTableNoExpand .table-row-expanded .truncationContent {
  white-space: normal;
  position: relative;
  line-height: unset;
}

.petitionTableNoExpand .table-row-expanded-content {
  visibility: collapse;
}

/* Hide increment up/down controls on TextField typ="number" because it isn't useful for GPA minimumGpa field. */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0;
  /* <-- Apparently some margin are still there even though it's hidden */
}

input[type=number] {
  -moz-appearance: textfield;
  /* Firefox */
}

a {
  cursor: pointer;
  text-decoration: none !important;
}

a:hover,
a:focus {
  text-decoration: underline !important;
}

#buttons {
  --experience-padding: 8px;
}

#calendar-btn {
  color: unset !important
}

#notifications-btn {
  color: unset !important
}

#grid-btn {
  color: unset !important
}

/* Accessibility overrides for Ellucian Dropdown items to support WCAG 2.2 text spacing */
/* Target dropdown menu items rendered by EDS Dropdown */
[class^="DropdownItem-root"], 
[class*=" DropdownItem-root"], 
[role="option"] {
  word-break: break-word !important;
  height: auto !important;
}
`, "",{"version":3,"sources":["webpack://./style/style.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,+GAA+G;EAC/G,sBAAsB;AACxB;;AAEA;EACE,+GAA+G;EAC/G,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,UAAU;EACV,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;AACf;;AAEA,4HAA4H;AAC5H;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;yDAEyD;AACzD;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,gHAAgH;AAChH;;EAEE,8CAA8C;EAC9C,wBAAwB;EACxB,SAAS;EACT,uEAAuE;AACzE;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA,yFAAyF;AACzF,wDAAwD;AACxD;;;EAGE,iCAAiC;EACjC,uBAAuB;AACzB","sourcesContent":[".login-body {\n  padding-top: 4rem;\n  background-image: url(\"https://cdn.elluciancloud.com/assets/EDS2/7.18.1/img/bg/DegreeWorks-CRM-Background.png\");\n  background-size: cover;\n}\n\n.logout-body {\n  background-image: url(\"https://cdn.elluciancloud.com/assets/EDS2/7.18.1/img/bg/DegreeWorks-CRM-Background.png\");\n  background-size: cover;\n}\n\n.loadingIndicator {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  z-index: 10100;\n}\n\n.dashboard-body {\n  background-color: #fafafa;\n}\n\n@media print {\n  .dashboard-body {\n    background-color: #ffffff;\n  }\n\n  body {\n    font: 9pt/1.5 Arial, sans-serif;\n  }\n\n  * {\n    overflow: visible !important;\n  }\n\n  #tooltip-icon-print {\n    display: none;\n  }\n}\n\n.no-padding {\n  padding: 0;\n}\n\nh1 {\n  padding-Top: 0.45rem !important;\n}\n\n.note-component:hover {\n  background-color: #f8f8f8;\n  cursor: pointer;\n}\n\n.note-component:hover>td>div>span {\n  text-decoration: underline;\n}\n\n.entity-component:hover {\n  background-color: #f8f8f8;\n  cursor: pointer;\n}\n\n.entity-component:hover>td:first-child {\n  text-decoration: underline;\n}\n\n.interal-field-width {\n  min-width: 75px;\n}\n\n.button-margin {\n  margin: 3px;\n}\n\ndiv.errorNotification {\n  top: 0;\n}\n\ndiv.errorNotification>div {\n  background-color: #D42828;\n}\n\n.hidden {\n  display: none !important;\n}\n\nfooter {\n  position: fixed;\n  width: 100%;\n  bottom: 0;\n  border-top: 0.0625rem solid #ccc;\n}\n\n.fade {\n  transition: all 1s ease-in-out;\n  opacity: 0;\n  display: none;\n}\n\nbutton.fab {\n  position: fixed;\n  bottom: 1rem;\n  right: 0.5rem;\n}\n\n/* Override material-ui OutlinedInput dropdown which we can't figure out how to get to through PaperProps, like in What-If */\nul {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.truncationContainer {\n  position: relative;\n  overflow: hidden;\n  height: 1em;\n}\n\n.truncationContent {\n  display: block;\n  position: absolute;\n  max-width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1em;\n}\n\n/* petitionRowExpanded */\n.petitionTable .table-row-expanded .truncationContainer {\n  overflow: visible;\n  height: unset;\n}\n\n.petitionTable .table-row-expanded .truncationContent {\n  white-space: normal;\n  position: relative;\n  line-height: unset;\n}\n\n/* On some of the Exception Management pages we do not want to see the new\n/* row but we do want the down-arrow to allow the column to expand.\n/* Here we are hiding the row using visibility:collapse */\n.petitionTableNoExpand .table-row-expanded .truncationContainer {\n  overflow: visible;\n  height: unset;\n}\n\n.petitionTableNoExpand .table-row-expanded .truncationContent {\n  white-space: normal;\n  position: relative;\n  line-height: unset;\n}\n\n.petitionTableNoExpand .table-row-expanded-content {\n  visibility: collapse;\n}\n\n/* Hide increment up/down controls on TextField typ=\"number\" because it isn't useful for GPA minimumGpa field. */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  /* display: none; <- Crashes Chrome on hover */\n  -webkit-appearance: none;\n  margin: 0;\n  /* <-- Apparently some margin are still there even though it's hidden */\n}\n\ninput[type=number] {\n  -moz-appearance: textfield;\n  /* Firefox */\n}\n\na {\n  cursor: pointer;\n  text-decoration: none !important;\n}\n\na:hover,\na:focus {\n  text-decoration: underline !important;\n}\n\n#buttons {\n  --experience-padding: 8px;\n}\n\n#calendar-btn {\n  color: unset !important\n}\n\n#notifications-btn {\n  color: unset !important\n}\n\n#grid-btn {\n  color: unset !important\n}\n\n/* Accessibility overrides for Ellucian Dropdown items to support WCAG 2.2 text spacing */\n/* Target dropdown menu items rendered by EDS Dropdown */\n[class^=\"DropdownItem-root\"], \n[class*=\" DropdownItem-root\"], \n[role=\"option\"] {\n  word-break: break-word !important;\n  height: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
